module.exports = __webpack_public_path__ + "assets/214b958fc8d34092ce06f2438afc0e4f.png";